import { render, staticRenderFns } from "./DeletePresetFolder.vue?vue&type=template&id=71ae67bc&"
import script from "./DeletePresetFolder.vue?vue&type=script&lang=js&"
export * from "./DeletePresetFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports